import { useState } from 'react';

export default function ContactInfo() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', phone: '', email: '', message: '' });
    }, 2000);
  };

  const contactCards = [
    {
      icon: 'ri-phone-line',
      title: '联系电话',
      content: '023-6288-8888',
      subContent: '工作日 9:00-18:00'
    },
    {
      icon: 'ri-mail-line',
      title: '电子邮箱',
      content: 'contact@nanshandiandi.org',
      subContent: '我们会在24小时内回复'
    },
    {
      icon: 'ri-map-pin-line',
      title: '办公地址',
      content: '重庆市南岸区花园路',
      subContent: '10号3幢第一层自编号103号',
      isAddress: true
    },
    {
      icon: 'ri-time-line',
      title: '工作时间',
      content: '周一至周五 9:00-18:00',
      subContent: '周末及节假日休息'
    }
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-6 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1E1E1E] mb-3 md:mb-4">联系我们</h2>
          <p className="text-sm md:text-lg text-[#6C6C6C]">期待与您携手，共同传递温暖</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-8 md:mb-12">
          {contactCards.map((card, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg md:rounded-xl p-3 md:p-6 text-center hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-10 h-10 md:w-16 md:h-16 bg-[#2A7A62] rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4">
                <i className={`${card.icon} text-lg md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-xs md:text-lg font-bold text-[#1E1E1E] mb-1 md:mb-2">{card.title}</h3>
              <p className={`text-[10px] md:text-sm font-semibold mb-1 ${card.isAddress ? 'text-[#2A7A62]' : 'text-[#2A7A62]'}`}>
                {card.content}
              </p>
              <p className="text-[9px] md:text-xs text-[#6C6C6C]">{card.subContent}</p>
            </div>
          ))}
        </div>

        {/* 留言表单 - 独占整行 */}
        <div className="max-w-2xl mx-auto">
          <form onSubmit={handleSubmit} className="bg-white rounded-lg md:rounded-xl p-4 md:p-8 shadow-md">
            <h3 className="text-lg md:text-2xl font-bold text-[#1E1E1E] mb-4 md:mb-6">在线留言</h3>
            
            {submitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-[#2A7A62] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-[#1E1E1E] mb-2">留言已提交</h4>
                <p className="text-[#6C6C6C]">感谢您的留言！我们会尽快与您联系。</p>
              </div>
            ) : (
              <div className="space-y-3 md:space-y-4">
                <div className="grid md:grid-cols-2 gap-3 md:gap-4">
                  <div>
                    <label className="block text-xs md:text-sm font-semibold text-[#1E1E1E] mb-1 md:mb-2">
                      您的姓名 <span className="text-[#E06B3D]">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-xs md:text-base border border-[#E0E0E0] rounded-lg focus:outline-none focus:border-[#2A7A62] transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>

                  <div>
                    <label className="block text-xs md:text-sm font-semibold text-[#1E1E1E] mb-1 md:mb-2">
                      联系电话 <span className="text-[#E06B3D]">*</span>
                    </label>
                    <input
                      type="tel"
                      required
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-xs md:text-base border border-[#E0E0E0] rounded-lg focus:outline-none focus:border-[#2A7A62] transition-colors"
                      placeholder="请输入您的联系电话"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs md:text-sm font-semibold text-[#1E1E1E] mb-1 md:mb-2">
                    电子邮箱
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-3 md:px-4 py-2 md:py-3 text-xs md:text-base border border-[#E0E0E0] rounded-lg focus:outline-none focus:border-[#2A7A62] transition-colors"
                    placeholder="请输入您的邮箱（选填）"
                  />
                </div>

                <div>
                  <label className="block text-xs md:text-sm font-semibold text-[#1E1E1E] mb-1 md:mb-2">
                    留言内容 <span className="text-[#E06B3D]">*</span>
                  </label>
                  <textarea
                    required
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    rows={4}
                    className="w-full px-3 md:px-4 py-2 md:py-3 text-xs md:text-base border border-[#E0E0E0] rounded-lg focus:outline-none focus:border-[#2A7A62] transition-colors resize-none"
                    placeholder="请输入您想对我们说的话..."
                    maxLength={500}
                  ></textarea>
                  <p className="text-[9px] md:text-xs text-[#6C6C6C] mt-1">最多500字</p>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#2A7A62] text-white py-2 md:py-3 px-4 md:px-6 rounded-lg text-xs md:text-base font-semibold hover:bg-[#236B54] transition-colors whitespace-nowrap cursor-pointer"
                >
                  提交留言
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
